import api from '../../services/service_question'

export default {
  data () {
    return {
      rounds: [],
      years: '',
      year: ''
    }
  },
  computed: {
    filterData: function () {
      let text = this.year.trim()
      return this.rounds.filter(round => {
        return (
          round.year.indexOf(text) > -1
        )
      })
    }
  },
  methods: {
    GETrounds () {
      api.getRounds(
        result => {
          if (result.result === true) {
            this.rounds = result.data
          } else {
            this.rounds = []
          }
        },
        error => {
          this.rounds = []
          alert(JSON.stringify(error))
        }
      )
    },
    getYears () {
      api.getYear(
        result => {
          if (result.result === true) {
            this.years = result.data
            // this.handleChange(result.data[0].year)
          } else {
            this.years = []
          }
        },
        error => {
          this.years = []
          alert(JSON.stringify(error))
        }
      )
    },
    go (obj) {
      if (parseInt(obj.assessment_type) > 0) {
        if (parseInt(obj.assessment_type) === 3 && parseInt(obj.univ) === 0) {
          this.$router.push({ name: 'aritnet', params: { key: obj.round_token } })
        } else if (parseInt(obj.assessment_type) === 3 && parseInt(obj.univ) === 1) {
          this.$router.push({ name: 'WFHOnline', params: { key: obj.round_token } })
        } else {
          this.$router.push({ name: 'assessment', params: { key: obj.round_token } })
        }
      }
    },
    handleChange (value) {
      this.year = value
    }
  },
  mounted () {
    this.GETrounds()
    this.getYears()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/main.js